// extracted by mini-css-extract-plugin
module.exports = {"root":"Checkout_root__2W-ep","productsCon":"Checkout_productsCon__1TaQ9","sectionHeader":"Checkout_sectionHeader__2OD9S","checkoutCon":"Checkout_checkoutCon__Lm1Me"};